
<template>
  <svg width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="m9 19l8-7l-8-7z"></path></svg>
</template>

<script>
export default {
  name: 'CaretRight'
}
</script>